var __WEBPACK_NAMESPACE_OBJECT__ = require("@performant-software/shared-components");